'use strict';

angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.NewController', [
	'mx.shell.ContextService',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	function newActionController(contextService, dialogOpener) {
		const vm = this;

		vm.execute = function (selectedObjects, action, presetFields, parentView) {
			let objectType;
			const _cxtObjTypes = contextService.val('SolutionBuilderAgent.ObjectTypes');

			if (Array.isArray(action.availableTypes) && Array.isArray(_cxtObjTypes)) {
				action.availableTypes.some(function (availableType) {
					return _cxtObjTypes.some(function (ctxType) {
						if (availableType === ctxType) {
							objectType = ctxType;
							return true;
						}
					});
				});
			} else {
				objectType = _cxtObjTypes && _cxtObjTypes[0];
			}

			let outerContext;
			if (action) {
				outerContext = Array.isArray(selectedObjects) && selectedObjects.length === 1 ? selectedObjects[0] : selectedObjects;
			}
			return dialogOpener
				.openNewDialog(objectType, action, selectedObjects, true, presetFields, parentView, undefined, outerContext)
				.newDialogOpenedPromise.then(function (view) {
					return {
						view: view,
					};
				})
				.catch(mx.logCatch);
		};
	},
]);
